import api from '../../api';
import { TPunterCategoryList } from './punterCategories.types';

export const puntercategoryList = 'bookie/options/punter-categories';

// List of Punter Categories
export const queryPunterCategoryList = () =>
  api.get<TPunterCategoryList[]>(puntercategoryList).then((res) => res.data);
